module.exports = __webpack_public_path__ + "img/RedteaSIM 3手机@2x.e70e92b3.png";